import Nullstack from 'nullstack';
export default function IconCraneOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-crane-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 21h6"
  }), "   ", Nullstack.element("path", {
    d: "M9 21v-12"
  }), "   ", Nullstack.element("path", {
    d: "M9 5v-2l-1.001 1.001"
  }), "   ", Nullstack.element("path", {
    d: "M6.005 5.995l-3.005 3.005h6"
  }), "   ", Nullstack.element("path", {
    d: "M13 9h8"
  }), "   ", Nullstack.element("path", {
    d: "M9 3l10 6"
  }), "   ", Nullstack.element("path", {
    d: "M17 9v4a2 2 0 0 1 2 2m-2 2a2 2 0 0 1 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}